import * as React from "react";
import { cn } from "@/lib/utils";

export interface EyebrowProps extends React.HTMLAttributes<HTMLParagraphElement> {
  variant?: "gold" | "teal";
  as?: "p" | "span" | "div";
}

export function Eyebrow({ variant = "gold", as: Comp = "p", className, ...props }: EyebrowProps) {
  return (
    <Comp
      className={cn(
        "font-mono text-eyebrow uppercase font-medium tracking-[0.16em]",
        variant === "gold"
          ? "text-brand-700 dark:text-brand-300"
          : "text-brand-700 dark:text-brand-300",
        className,
      )}
      {...props}
    />
  );
}

export default Eyebrow;
